<template>
    <div class="controls d-print-none">
        <div class="form-row">
            <!-- Search -->
            <div class="col-6 col-sm-4 form-inline search">
                <label for="Search" class="sr-only">Search</label>
                <b-input-group>
                    <template v-slot:prepend>
                        <b-input-group-text
                            ><fa-icon
                                class="text-muted"
                                icon="search"
                                size="sm"
                            ></fa-icon
                        ></b-input-group-text>
                    </template>
                    <b-form-input
                        id="Search"
                        placeholder="Search for a Participant"
                        size="sm"
                        trim
                        type="search"
                        v-model="search"
                        @input="onSearch()"
                    ></b-form-input>
                    <template v-slot:append>
                        <b-button
                            aria-label="Clear search"
                            title="Clear search"
                            variant="secondary"
                            @click="clearSearch()"
                        >
                            <fa-icon icon="times" size="sm"></fa-icon>
                        </b-button>
                    </template>
                </b-input-group>
            </div>

            <!-- Total Results -->
            <div class="col-6 col-sm-4 text-center">
                <grid-controls-count
                    :current-cage="currentPage"
                    :per-page="perPage"
                    :total-results="totalResults"
                ></grid-controls-count>
            </div>

            <!-- Results Per Page -->
            <div class="col-sm-4 form-inline per-page d-none d-sm-flex">
                <label for="perPage">Results Per Page</label>
                <b-form-select
                    :options="pageOptions"
                    id="perPage"
                    size="sm"
                    v-model="perPage"
                    @change="onResultsChange"
                >
                </b-form-select>
            </div>
        </div>
    </div>
</template>

<script>
import GridControlsCount from "./GridControlsCount";

export default {
    name: "GridControls",
    components: {
        GridControlsCount
    },
    props: {
        currentPage: {
            type: Number,
            default: 0
        },
        totalResults: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            search: null,
            pageOptions: [10, 20, 50],
            perPage: 20
        };
    },
    methods: {
        clearSearch() {
            this.search = null;
            this.onSearch();
        },
        onSearch() {
            this.$emit("onSearch", this.search);
        },
        onResultsChange() {
            this.$emit("onResultsChange", this.perPage);
        }
    }
};
</script>

<style lang="scss">
.controls {
    font-size: 0.875rem;
    padding: $spacer-2 $spacer;

    @include media-breakpoint-up(lg) {
        padding: $spacer;
    }

    .form-row {
        align-items: center;
    }

    .search .input-group {
        width: 100%;
    }

    .per-page {
        display: flex;
        justify-content: flex-end;
    }
}
</style>
